<svg width="180" height="130" aria-label="A chart." style="overflow: hidden;">                
    <rect x="0" y="0" width="180" height="130" stroke="none" stroke-width="0" fill="#ffffff"></rect>
    <g>
        <rect x="0" y="20" width="180" height="130" stroke="none" stroke-width="0" fill-opacity="0" fill="#ffffff"></rect>
        <g>
            <g>
                <rect x="8" y="16" width="18" height="107" stroke="none" stroke-width="0" fill="#4374e0"></rect>
                <rect x="79" y="14" width="18" height="109" stroke="none" stroke-width="0" fill="#4374e0"></rect>
                <rect x="27" y="55" width="18" height="68" stroke="none" stroke-width="0" fill="#53a8fb"></rect>
                <rect x="98" y="37" width="19" height="86" stroke="none" stroke-width="0" fill="#53a8fb"></rect>
                <rect x="46" y="54" width="19" height="69" stroke="none" stroke-width="0" fill="#f1ca3a"></rect>
                <rect x="118" y="53" width="18" height="70" stroke="none" stroke-width="0" fill="#f1ca3a"></rect>
            </g>
            <g>
                <rect x="0" y="123" width="140" height="1" stroke="none" stroke-width="0" fill="#333333"></rect>
            </g>
        </g>
    </g>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/column-chart/column-chart.html